import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

// Lazy Loaded Modules
const Bootcamp1Activities = dynamic(() => import('./Bootcamp1Activities'))
const Bootcamp2Activities = dynamic(() => import('./Bootcamp2Activities'))
const Bootcamp3Activities = dynamic(() => import('./Bootcamp3Activities'))
const Bootcamp4Activities = dynamic(() => import('./Bootcamp4Activities'))
const Bootcamp5Activities = dynamic(() => import('./Bootcamp5Activities'))

const MultiplicationActivities = (activityData: ActivityGroupProps): React.ReactElement => {
  const router = useRouter()
  const { moduleKey } = router.query

  switch (moduleKey) {
    case '1':
      return <Bootcamp1Activities {...activityData} />
    case '2':
      return <Bootcamp2Activities {...activityData} />
    case '3':
      return <Bootcamp3Activities {...activityData} />
    case '4':
      return <Bootcamp4Activities {...activityData} />
    case '5':
      return <Bootcamp5Activities {...activityData} />
    default:
      return <></>
  }
}

export default MultiplicationActivities
